// extracted by css-extract-rspack-plugin
export default {"clickable":"ma824I","spacer":"k_0LRV","page":"b7X7cA","map":"DxzRRS","inputs":"dv16jW","btnSignIn":"jia68i"};